import axios from 'axios';

import DOService from "@/services/do.service";

const MSG_START_ALLOC = "Allocating Orders... ( Jangan refresh atau tutup Window ini )"
const MSG_DONE_ALLOC = "Selesai Allocate"

export default {
    name: 'TxAllocate',
    data() {
      return {
          titleAllocate: MSG_START_ALLOC,
          headerBgVariant: 'dark',
          headerTextVariant: 'light',
          processAllocate: null,
          errorAllocate: '',
          allocateResult: [
              {
                  status: "OK",
                  message: "DO: xxxxx OK"
              },
              {
                  status: "OK",
                  message: "DO: yyyyy OK"
              }
          ],
      }
    },
    methods: {
        doCallServerAllocate(selectedDo) {
            /* eslint-disable no-console */

            this.allocateResult = []
            this.processAllocate = true
            this.titleAllocate = MSG_START_ALLOC

            let vm = this
            DOService.bulkAllocate(selectedDo, function(error,doId) {

                //console.log(">> ******** {}: {}",doId, error.response )

                if (error.response.status === 401) {
                    vm.allocateResult.push( {
                        status: 401,
                        message: 'Unauthorized'
                    })
                    vm.$store.dispatch('auth/logout');
                    vm.$router.push('/login')
                    return
                }
                vm.allocateResult.push( {
                    status: error.response.status,
                    message: 'DO : ' + doId +
                        ' , Error: ' +
                        ((error.response && error.response.data) ?
                            error.response.data.error :
                            error.toString())
                })

            }).then(
                axios.spread((...responses) => {
                    for(let iii = 0; iii < responses.length; iii++) {
                        if (!responses[iii]) {
                            continue
                        }
                        vm.allocateResult.push({
                                status: 200,
                                message: 'DO : ' + selectedDo[iii]
                                    + ' ' + responses[iii].data.message
                            }
                        )
                    }
                }))

            /* eslint-enable no-console */

            let iId = null;
            let fCheck = function(){
                if (vm.allocateResult.length >= selectedDo.length ) {
                    clearInterval(iId);
                    vm.processAllocate = false
                    vm.titleAllocate = MSG_DONE_ALLOC
                }
            };
            iId = setInterval(fCheck, 500);

        },
    },
}